// Adapted from @react-admin/ra-form-layout@1.9.0 — see ../README.md
import { ReactNode } from 'react'
import { useTranslate } from 'react-admin'

/**
 * Renders either the step's inputs or just its label, selected by the `intent`
 * prop — the React Multipass pattern:
 * https://marmelab.com/blog/2018/10/18/react-render-context-pattern.html
 *
 * To be used as a child of <WizardForm>.
 *
 * Deviation from the original: react-admin 3 wrapped every child in
 * <FormInput> to apply `basePath`, `record`, `resource`, `variant` and
 * `margin`. react-admin 5 removed FormInput along with prop injection —
 * inputs read what they need from context — so the children render directly
 * and those props are gone.
 */
export const WizardFormStep = ({ children, intent, label }: WizardFormStepProps) => {
  const translate = useTranslate()

  if (intent === 'label') {
    return <span>{translate(label, { _: label })}</span>
  }

  return <>{children}</>
}

export interface WizardFormStepProps {
  children?: ReactNode
  intent?: 'step' | 'label'
  label: string
  /** Accepted and ignored: <WizardForm> passes step metadata through. */
  section?: any
  checkFields?: string[]
}

export default WizardFormStep
